import { ProjectSchedules as ProjectSchedulesIcon } from "./../../Components/Icon";
import { navigationMapBuilder } from "./helpers";
import ProjectSchedules from "./../../Pages/ProjectSchedules";

const navigation = () => ([
  {
    header: "Project Schedules",
    links: [
      {
        text: "Project Schedules",
        icon: ProjectSchedulesIcon,
        route: "projectschedules",
        component: ProjectSchedules,
      },
    ],
  },
]);

const navigationMap = (parentRoute) =>
  navigationMapBuilder(parentRoute, navigation);

export default navigationMap;
